import { ResourceProps } from 'react-admin';
import icon from '@material-ui/icons/People';
import create from './create';
import edit from './edit';
import list from './list';

const valorizationItems: ResourceProps = {
  name: 'valorization-items',
  icon,
  options: { label: 'Valorização' },
  create,
  edit,
  list
};

export default valorizationItems;
